import loggingService from 'common/logging/loggingService';
import notificationService from 'common/notificationService';
import AsyncButton from 'common/ui/AsyncButton';
import ValidationError from 'common/validationError';
import { Partner } from 'features/settings/importMapping/partner';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import partnerIntegrationService from './partnerIntegrationService';

export interface PartnerImportModalProps {
    merchantId: string;
    partner: Partner;
    onHide(): void;
}

const PartnerImportModal: React.FC<PartnerImportModalProps> = props => {

    async function onRun() {
        try {
            await partnerIntegrationService.importMappingData(props.merchantId, props.partner);
            notificationService.success("Mapping data successfully imported");
            props.onHide();
        }
        catch (err) {
            loggingService.error("Unable to import mapping data", err as Error);
            const validationError = err as ValidationError;
            notificationService.error(validationError.errors?.join(", ") ?? "Unable to import mapping data");
        }
    }

    return <Modal show onHide={props.onHide} backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>
                Import mapping data
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="mt-4">
                <p>Import the mapping data (Commodities, Locations, etc.) that are needed to import and export ERP/bid data</p>
                <p>This should only be necessary when first setting up an ERP integration</p>
            </div>

        </Modal.Body>
        <Modal.Footer>
            <div className="pull-right">
                <Button variant="secondary" className="ml-2" onClick={props.onHide}>
                    Cancel
                </Button>&nbsp;
                <AsyncButton variant="primary" onClickAsync={onRun}>
                    Run
                </AsyncButton>
            </div>
        </Modal.Footer>
    </Modal>;

}

export default PartnerImportModal;